import type { ComponentProps, FC } from 'react';

import { PersonalizationCard as SharedPersonalizationCard } from '@shared/products-components';

import type { ActivePAPIProductWithAvatarData } from './types';
import { PersonalizationAvatar } from './components/PersonalizationAvatar';
import { ColorChange } from './customizations/ColorChange';
import { AliasChange } from './customizations/AliasChange';
import { DashboardAppearanceChange } from './customizations/DashboardAppearanceChange';
import { useActivePAPIProduct } from '../../ActivePAPIProductContext';

type Props = Partial<Pick<ComponentProps<typeof SharedPersonalizationCard>, 'actions'>> & {
    'data-cy': string;
};

export const PersonalizationCard: FC<Props> = ({ actions, 'data-cy': dataCy }) => {
    const {
        localizedName,
        _embedded: {
            customization: { name },
        },
    } = useActivePAPIProduct<ActivePAPIProductWithAvatarData>();

    const actionsList = actions || [
        <AliasChange key="alias-change" />,
        <ColorChange key="color-change" />,
        <DashboardAppearanceChange key="dashboard-change" />,
    ];

    return (
        <SharedPersonalizationCard
            actions={actionsList}
            avatar={<PersonalizationAvatar />}
            subtitle={localizedName}
            alias={name}
            data-cy={dataCy}
        />
    );
};
